export enum ELayerType {
  VECTOR = 'vector',
  RASTER = 'raster',
  STREAM = 'stream',
}

export enum ELayerStyleLineCap {
  BUTT = 'butt',
  ROUND = 'round',
  SQUARE = 'square',
  INHERIT = 'inherit',
}

export enum ELayerStyleLineJoin {
  MITER = 'miter',
  ROUND = 'round',
  BEVEL = 'bevel',
  INHERIT = 'inherit',
}

export enum ELayerStyleFillRule {
  NONZERO = 'nonzero',
  EVENODD = 'evenodd',
  INHERIT = 'inherit',
}

export enum ELayerStyleMarkerPreset {
  DEFAULT = 'default',
  RLS = 'rls',
  REB = 'reb',
  OES = 'os',
  BPLA = 'bpla',
}

export enum ELayerStyleDashArray {
  SOLID = '',
  DASHED = '3 6',
  DOTTED = '0 6',
}

export enum ELayerFeatureStyleTrackLengthMode {
  COUNT = 'count',
  DURATION = 'duration',
}

export enum ELayerFeatureSearchType {
  PARTIAL = 'partial',
  EXACT = 'exact',
}

export enum ELayerWidgetType {
  FOCUSING = 'focusing',
  DESCRIPTION = 'description',
  GEOMETRY = 'geometry',
  MARKDOWN = 'markdown',
}

export enum ELayerStyleBadgePosition {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM = 'bottom',
}
